// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"601":"a586a570","1002":"93f3d1a0","2346":"b2324613","7258":"57cde131","8355":"a586a570"}[chunkId] + ".chunk.css";
};